import React, { ReactNode } from 'react';
import IconPerksLogo from '../../../../../../../../assets/svg/icon-perks-logo.svg';
import { PerksSignupWrapper } from './PerksSignupWrapper';
import { styles } from './PerksLayout.css';

export const PerksLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <PerksSignupWrapper>
      <div className={styles.logoContainer}>
        <IconPerksLogo data-testid="perks-logo" />
      </div>
      {children}
    </PerksSignupWrapper>
  );
};
